export type RegisterAccountType = "user" | "partner";

export interface RegisterRequest {
  accountType: RegisterAccountType;
  firstName: string;
  lastName: string;
  orgName?: string | null;
}

export interface RegisterResponse {
  ok: boolean;
  createdOrgId?: string | null;
}

import { ApiClient, ApiError } from "../lib/api/baseClient";

export interface RegisterApiError extends Error {
  code: string;
  httpStatus: number;
}

// Create client for registration
const registerClient = new ApiClient();

export async function callAuthRegister(
  _apiBaseUrl: string,
  token: string,
  payload: RegisterRequest,
): Promise<RegisterResponse> {
  try {
    registerClient.setAuthToken(token);
    return await registerClient.post<RegisterResponse>(
      "/auth/register",
      payload,
      { defaultErrorCode: "REGISTER_FAILED" },
    );
  } catch (e) {
    if (e instanceof ApiError) {
      const err = new Error(e.code) as RegisterApiError;
      err.code = e.code;
      err.httpStatus = e.httpStatus;
      throw err;
    }
    throw e;
  }
}
